<template>
    <div class="container mescroll-touch">
        <div class="topdh" @click="back"><img src="../../assets/images/bjback.png" class="homeimg" />首页&nbsp;>&nbsp;会议日程
        </div>
        <div class="meetinginfo">
            <div class="infoitem">
                <img src="../../assets/images/meetingtime.png" class="meetingicon" />
                <div class="meetingtext">{{ list.DateStr }}</div>
            </div>
            <div class="infoitem1">
                <img src="../../assets/images/meetingziplace.png" class="meetingicon" />
                <div class="meetingtext">{{ list.Address }}</div>
            </div>
        </div>
        <div class="titlemain">
            <!-- <img src="../../assets/images/b.png" class="titleborder" /> -->
            <div class="titletext">{{ title }}</div>
        </div>
        <div class="listmain">
            <div class="listitem" v-for="(item, index) in list.Detail" :key="index">
                <div class="itempoint">
                    <img v-if="item.IsImportant" src="../../assets/images/type2icon.png" class="pointimg" />
                    <img v-else src="../../assets/images/type1icon.png" class="pointimg" />
                </div>
                <div class="time" :class="item.IsImportant ? 'textimp' : ''">{{ item.StartTimeStr }} - {{
                    item.EndTimeStr
                }}</div>
                <div class="title" :class="item.IsImportant ? 'textimp' : ''">{{ item.Title }}</div>
                <div class="jb" v-if="item.hasjb">
                    <div>发言嘉宾：</div>
                    <div v-for="(items, index) in item.Talker" :key="index" class="jobrow">
                        <div v-if="items.TalkerType == 1" :class="items.Name.length == 2 ? 'zijv' : ''">
                            {{ items.Name }}
                        </div>
                        <div v-if="items.TalkerType == 1" class="jobcenter">
                            {{ items.Title }}
                        </div>
                        <div v-if="items.TalkerType == 1" class="hosp">
                            {{ items.Hospital }}
                        </div>
                    </div>
                </div>
                <div class="zcr" v-if="item.haszcr">
                    <div>主持人：</div>
                    <div v-for="(items, index) in item.Talker" :key="index" class="jobrow">
                        <div v-if="items.TalkerType == 2" :class="items.Name.length == 2 ? 'zijv' : ''">
                            {{ items.Name }}
                        </div>
                        <div v-if="items.TalkerType == 2" class="jobcenter">
                            {{ items.Title }}
                        </div>
                        <div v-if="items.TalkerType == 2" class="hosp">
                            {{ items.Hospital }}
                        </div>
                    </div>
                </div>
                <div class="jz" v-if="item.hasjz">
                    <div style="display: flex; flex-direction: row;">
                        <div class="jzjz">讲</div>
                        <div>者：</div>
                    </div>

                    <div v-for="(items, index) in item.Talker" :key="index" class="jobrow">
                        <div v-if="items.TalkerType == 3" :class="items.Name.length == 2 ? 'zijv' : ''">
                            {{ items.Name }}
                        </div>
                        <div v-if="items.TalkerType == 3" class="jobcenter">
                            {{ items.Title }}
                        </div>
                        <div v-if="items.TalkerType == 3" class="hosp">
                            {{ items.Hospital }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="backbtn" @click="back()">
            <img src="../../assets/images/backicon.png" alt="">
        </div>
    </div>
</template>

<script>
// import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'custommeetinginfo',
    data() {
        return {
            list: [],
            title: this.$route.query.title,
        }
    },
    mixins: [mixin],
    components: {
        // floatback
    },
    created() {
        this.initacmedShare();
        document.title = "会议日程";
        // this.title = this.$route.query.title
        this.getdate()
    },
    mounted() {
        this.initDrag();
    },
    methods: {
        getdate() {
            let that = this;
            this.$axios.get('/api/api/web/activity/GetSceduleDetail?id=' + this.$route.query.Id).then(res => {
                that.list = res.Data;
                console.log(res.Data.Detail)
                for (var d = 0; d < that.list.Detail.length; d++) {
                    that.list.Detail[d].hasjb = false;
                    that.list.Detail[d].haszcr = false;
                    that.list.Detail[d].hasjz = false;
                    for (var i = 0; i < that.list.Detail[d].Talker.length; i++) {
                        // console.log(res.Data.Detail[d].Talker[i].TalkerType)
                        let dtext = that.list.Detail[d].Talker[i]
                        if (dtext.TalkerType == 1) {
                            that.list.Detail[d].hasjb = true
                        }
                        if (dtext.TalkerType == 2) {
                            that.list.Detail[d].haszcr = true
                        }
                        if (dtext.TalkerType == 3) {
                            that.list.Detail[d].hasjz = true
                        }
                        console.log(this.list)
                    }
                }

            })
        },
        back() {
            this.$router.replace({
                path: "custom",
                query: {
                    Id: this.$route.query.ActivityId,
                },
            });
        },
        initDrag() {
            const btn = document.querySelector('.backbtn');
            if (!btn) return;

            // 触摸开始（移动端）
            btn.addEventListener('touchstart', (e) => {
                this.isDragging = true;
                // 获取初始触摸位置
                this.startX = e.touches[0].clientX;
                this.startY = e.touches[0].clientY;
                // 获取按钮当前位置
                const rect = btn.getBoundingClientRect();
                this.btnX = rect.left;
                this.btnY = rect.top;
                // 阻止默认行为
                // e.preventDefault();
            });

            // 触摸移动（移动端）
            btn.addEventListener('touchmove', (e) => {
                if (!this.isDragging) return;
                // 计算移动距离
                const moveX = e.touches[0].clientX - this.startX;
                const moveY = e.touches[0].clientY - this.startY;
                // 设置按钮新位置
                btn.style.left = `${this.btnX + moveX}px`;
                btn.style.top = `${this.btnY + moveY}px`;
                // 清除原有right/transform
                btn.style.right = 'auto';
                btn.style.transform = 'none';
                e.preventDefault();
            });

            // 触摸结束（移动端）
            btn.addEventListener('touchend', () => {
                this.isDragging = false;
            });

            // 兼容PC端鼠标操作
            btn.addEventListener('mousedown', (e) => {
                this.isDragging = true;
                this.startX = e.clientX;
                this.startY = e.clientY;
                const rect = btn.getBoundingClientRect();
                this.btnX = rect.left;
                this.btnY = rect.top;
                e.preventDefault();
            });

            document.addEventListener('mousemove', (e) => {
                if (!this.isDragging) return;
                const moveX = e.clientX - this.startX;
                const moveY = e.clientY - this.startY;
                btn.style.left = `${this.btnX + moveX}px`;
                btn.style.top = `${this.btnY + moveY}px`;
                btn.style.right = 'auto';
                btn.style.transform = 'none';
            });

            document.addEventListener('mouseup', () => {
                this.isDragging = false;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
    // background: rgb(227, 235, 253);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.pos {
    position: relative;
}

.meetinginfo {
    // position: absolute;
    // left: 50%;
    // transform: translateX(-50%);
    // top: 20%;
    display: flex;
    flex-direction: column;
    width: 95%;
    justify-content: center;
    margin: auto;
    font-weight: bold;
    margin-top: .5rem;
}

.meetingicon {
    width: 6%;
    height: .6rem;
    // margin-top: .05rem;
}

.infoitem {
    width: 100%;
    display: flex;
    flex-direction: row;
}

.infoitem1 {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-top: .2rem;
}

.meetingtext {
    // color: #fff;
    margin-left: .2rem;
    color: rgb(0, 53, 133);
}

.titlemain {
    width: 90%;
    margin: 0.6rem auto;
    position: relative;
    margin-top: 0.3rem;
}

.titleborder {
    display: block;
    width: 100%;
}

.titletext {
    // position: absolute;
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%, -50%);
    // color: #6E56FB;
    // font-weight: bold;
    // font-size: .45rem;
    // width: 90%;
    // text-align: center;
    color: rgb(0, 53, 133);
    font-weight: bold;
    font-size: .47rem;
    width: 90%;
    margin: auto;
    text-align: center;
}

.listmain {
    width: 90%;
    margin: auto;
    margin-bottom: 0.6rem;
    padding-left: 0.5rem;
    box-sizing: border-box;
    border-left: 1px solid rgb(0, 53, 133);
}

.time {
    color: rgb(0, 53, 133)
}

.title {
    color: rgb(0, 53, 133);
    margin: 0.1rem 0;
}

.textimp {
    font-weight: bold;
}

.listitem {
    border-bottom: 0.026667rem solid rgb(0, 53, 133);
    box-sizing: border-box;
    padding: 0.2rem 0;
    position: relative;
    padding-top: 0;
    margin-bottom: 0.3rem;
}

.zcr {
    // display: flex;
    // flex-direction: row;
    font-size: .35rem;
}

.jz {
    // display: flex;
    // flex-direction: row;
    font-size: .35rem;
}

.jb {
    font-size: .35rem;
}

.itempoint {
    position: absolute;
    width: 4%;
    left: -0.68rem;
    background: #fff;
}

.pointimg {
    display: block;
    width: 100%;
}

.jzjz {
    letter-spacing: .35rem;
}

.jobrow {
    display: flex;
    flex-direction: row;
    align-items: baseline;
}

.jobcenter {
    margin: 0 .2rem;
}

.zijv::first-letter {
    letter-spacing: .35rem;
}

.hosp {
    font-size: .3rem;
    max-width: 6.2rem;
}

.topdh {
    font-family: cursive;
    font-weight: bold;
    background: #003583;
    color: #fff;
    padding: 0.3rem;
}

.homeimg {
    width: 5%;
    display: inline-block;
    vertical-align: text-bottom;
    margin-right: 0.1rem;
}

.backbtn {
    width: 13%;
    position: fixed;
    right: 0;
    top: 50%;
    opacity: .8;
    transform: translateY(-50%);
    z-index: 99999;
    /* 新增拖动相关样式 */
    touch-action: none;
    /* 禁用浏览器默认触摸行为 */
    user-select: none;
    /* 防止拖动时选中文字 */
    -webkit-user-drag: element;
    /* 开启移动端拖动 */
    cursor: move;
    /* 鼠标指针提示可拖动 */
    transition: transform 0.1s ease;
    /* 拖动过渡更顺滑 */
}

.backbtn:active {
    opacity: 1;
    /* 拖动时提高透明度，增强反馈 */
    transform: translateY(-50%) scale(1.05);
    /* 拖动时轻微放大，提升体验 */
}

.backbtn img {
    width: 100%;
    pointer-events: none;
    /* 让拖动事件穿透到父元素 */
}
</style>